import { IBestCombo } from '@/store/ducks/combos/types';

import { ComboSingleProduct } from './ComboSingleProduct';

interface ComboProductsProps {
  best_combos: IBestCombo[];
}

export function ComboSingleProducts({ best_combos }: ComboProductsProps) {
  if (!best_combos || !best_combos.length) return null;

  const comboProducts = best_combos
    .map((combo) => combo.main_products)
    .flat()
    .sort((a, b) => (a.min_quantity < b.min_quantity ? -1 : 1))
    .slice(0, 3);

  return (
    <div className="d-flex flex-column flex-md-row gap-4">
      {comboProducts.map((product) => (
        <ComboSingleProduct product={product} />
      ))}
    </div>
  );
}
